// API Configuration for Selezium Shop

// Public API endpoints (userapi lambda)
export const PUBLIC_API_URL = 'https://yiyxicsmmboihgxch6ukyfn6rm0ksefj.lambda-url.eu-west-2.on.aws';

// Admin API endpoints (admin lambda)
export const ADMIN_API_URL = 'https://ewpfvffejfybyxcgnhim2bwwyi0gybco.lambda-url.eu-west-2.on.aws';

// Auth API endpoints (auth lambda)
export const AUTH_API_URL = 'https://rqjfp5mhyqv3e6bnudv3axzk6e0wgxqh.lambda-url.eu-west-2.on.aws';

// Cart API endpoints (cart lambda)
export const CART_API_URL = 'https://t7e74nfz6hisrvwqpzxzgj6gry0wsuyn.lambda-url.eu-west-2.on.aws';

// Deprecated API Gateway endpoints (to be removed)
// export const DEPRECATED_API_GATEWAY = 'https://2ism51zck5.execute-api.eu-west-2.amazonaws.com/production';

export default {
  PUBLIC_API_URL,
  ADMIN_API_URL,
  AUTH_API_URL,
  CART_API_URL
}; 